import { Trans } from "react-i18next";

const News12 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##12"}
            components={{
                section: <section />,
                h3: <h3>""</h3>, // fake empty content to avoid warnings
                p: <p />,
                strong: <strong />
            }}
        />
    );
};

export { News12 };
